export default "__VITE_ASSET__ebbfd95f__"